var React = require('react');

function FrontendDropdownMenuSuppression (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z","key":0}),React.createElement("path",{"fill":"#000000","d":"M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM8 11.5c0-1.933 1.567-3.5 3.5-3.5 0.763 0 1.47 0.245 2.045 0.659l-4.885 4.886c-0.415-0.575-0.66-1.282-0.66-2.045zM11.5 15c-0.763 0-1.47-0.245-2.045-0.659l4.886-4.886c0.415 0.575 0.659 1.282 0.659 2.045 0 1.933-1.567 3.5-3.5 3.5z","key":1})]);
}

FrontendDropdownMenuSuppression.displayName = "FrontendDropdownMenuSuppression";

FrontendDropdownMenuSuppression.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendDropdownMenuSuppression;

FrontendDropdownMenuSuppression.default = FrontendDropdownMenuSuppression;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-dropdown-menu-suppression.svg
// module id = 1012
// module chunks = 0